import { Modal } from "antd";
import Button from '~/components/Shared/Button';

/**
 * 
 * @param {{
 *  title: string;
 *  footer: JSX.Element | "negative-affirmative" | "affirmative" | "close";
 *  onNegative?: () => void;
 *  onAffirmative?: () => void;
 *  onClose?: () => void;
 *  negativeText?: React.ReactNode;
 *  affirmativeText?: React.ReactNode;
 *  negativeProps?: object;
 *  affirmativeProps?: object;
 *  hideCloseButton?: boolean;
 *  children: React.ReactNode;
 * }} props 
 * @returns 
 */
export default function SimpleModal({
    title,
    footer,
    onNegative = () => {}, onAffirmative = () => {}, onClose = () => {},
    negativeText = "Cancel", affirmativeText = "Confirm",
    negativeProps = {}, affirmativeProps = {},
    hideCloseButton = false,
    children,
}) {

    let _footer;
    if (footer === "negative-affirmative" || footer === "affirmative") {
        _footer = (
            <>
                { footer === "negative-affirmative" &&
                    <Button onClick={onNegative} {...negativeProps}>{negativeText}</Button>
                }
                <Button type="primary" onClick={onAffirmative} {...affirmativeProps}>{affirmativeText}</Button>
            </>
        )
    } else if (footer === "close") {
        _footer = (
            <>
                <Button onClick={onClose}>Close</Button>
            </>
        )
    } else {
        _footer = footer;
    }

    return (
        <Modal
            open={true}
            title={title}
            maskClosable={false}
            closable={!hideCloseButton}
            onCancel={onClose ?? onNegative}
            maskTransitionName="maskTransitionName"
            footer={_footer}
        >{children}</Modal>
    );
}